import { render, staticRenderFns } from "./CardIndicadorl.vue?vue&type=template&id=56ec3b56&scoped=true"
import script from "./CardIndicadorl.vue?vue&type=script&lang=js"
export * from "./CardIndicadorl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ec3b56",
  null
  
)

export default component.exports